module.exports = __webpack_public_path__ + "media/audio37.52c67d18.mp3";